<template>
  <client-only>
    <Header />
    <LoyaltyHeader />
    <slot />
    <Footer />
    <template #fallback>
      <Loading class="isLoading" />
    </template>
  </client-only>
</template>

<script setup>
  
</script>